
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ir/stock/info",
      function () {
        return require("private-next-pages/en/ir/stock/info.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/ir/stock/info"])
      });
    }
  